module.exports = __webpack_public_path__ + "static/media/YamBowl.561e68fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Yamamoto/YamBowl.jpg
// module id = 5770
// module chunks = 0